export default "__VITE_ASSET__CK89Ub2O__"